const gameIds = {
  A11Y_PROTOTYPE: 'accessibility_prototype',
  ALL_ABOARD: 'all_aboard',
  API_FAILURES: 'API_FAILURES',
  ARBA: 'amplify_reading_benchmark_assessment',
  BECAUSE_THIS_THAT: 'because_this_that',
  BEST_BUDDY: 'best_buddy',
  BLENDING: 'blending',
  BOOK_CLUB: 'book_club',
  CARTOON_FACTORY: 'cartoon_factory',
  CITY_PLANNER: 'city_planner',
  CLOSE_READING: 'closereading',
  CODEX: 'codex',
  CONNECT_IT: 'connect_it',
  CURIOSO_CALLING: 'curioso_calling',
  CURIOSO_CROSSING: 'curioso_crossing',
  CURIOUS_CASES: 'curious_cases',
  CUT_IT_OUT: 'cut_it_out',
  DEBATE_A_BALL: 'debate_a_ball',
  DIRECTORS_CUT: 'directors_cut',
  DOUBLE_TROUBLE: 'double_trouble',
  E_READER: 'ereader',
  ESTA_O_AQUELLA: 'esta_o_aquella',
  FIELD_OBSERVER: 'field_observer',
  FOOD_TRUCK: 'food_truck',
  FOOD_TRUCK_CHEFS_SPECIALS: 'food_truck_chefs_specials',
  FOTO_FOTO_COGNADO: 'foto_foto_cognado',
  GEM_NYE_FRIENDS: 'gem_nye_friends',
  GRUMPY_GOBLINS: 'grumpy_goblins',
  HANGRY_GOBLINS: 'hangry_goblins',
  HUB: 'hub',
  IDIOMATICA: 'idiomatica',
  INKBLOTT: 'inkblott',
  JUEGA_Y_CONJUGA: 'juega_y_conjuga',
  LA_RANA_BRINCACHARCOS: 'la_rana_brincacharcos',
  LETTER_SOUND_CORRESPONDENCES: 'letter_sound_correspondences',
  MESSAGE_IN_A_BOTTLE: 'message_in_a_bottle',
  METAGAME: 'AQUA_METAGAME',
  METAGAME_CHALLENGE_QUEST: 'AQUA_METAGAME.challengeQuest',
  METAGAME_CURIOSO_AUGMENTATIONS_EARNED: 'AQUA_METAGAME.curioso.augmentations.earned',
  METAGAME_CURIOSO_AUGMENTATIONS_SELECTED: 'AQUA_METAGAME.curioso.augmentations.selected',
  METAGAME_CURIOSO_ITEMS: 'AQUA_METAGAME.curioso.items',
  METAGAME_CURIOSO_POWERS: 'AQUA_METAGAME.curioso.powers',
  METAGAME_CURIOSO_SELECTED: 'AQUA_METAGAME.curioso.selected',
  METAGAME_MAP_AREAS: 'AQUA_METAGAME.map.state',
  METAGAME_QUEST_CURRENT: 'AQUA_METAGAME.quest.current',
  METAGAME_QUEST_FAILURES: 'AQUA_METAGAME.quest.failures',
  METAGAME_QUEST_HISTORY: 'AQUA_METAGAME.quest.history',
  METAGAME_QUEST_NOTEBOOK: 'AQUA_METAGAME.quest.notebook',
  METAGAME_SIDE_QUEST: 'AQUA_METAGAME.sideQuest',
  METAGAME_USAGE: 'AQUA_METAGAME.usage',
  METAGAME_WORKSHOP: 'AQUA_METAGAME.workshop',
  METAGAME_WORKSHOP_CURRENT: 'AQUA_METAGAME.workshop.current',
  METAGAME_WORKSHOP_HISTORY: 'AQUA_METAGAME.workshop.history',
  METAGAME_WORKSHOP_REWARDS: 'AQUA_METAGAME.workshop.rewards',
  MIND_THE_GAP: 'mind_the_gap',
  NEW_GAME: 'new_game',
  NEWSFLASH: 'newsflash',
  BOOST_FLUENCY: 'boost_fluency',
  PARROT_THEATER: 'parrot_theater',
  PICKY_GOBLINS: 'picky_goblins',
  PICTURE_THIS: 'picture_this',
  PLACEMENT_TOOL: 'placement_tool',
  PLANTORRES: 'plantorres',
  POETS_PATH: 'poets_path',
  PUNCHLINE: 'punchline',
  READ_ALL_ABOUT_IT: 'read_all_about_it',
  REAL_WORD_READING: 'real_word_reading',
  RHYME_TIME: 'rhyme_time',
  ROBOVOICE_PROTOTYPE: 'robovoice_prototype',
  SEGMENTING: 'segmenting',
  SHADES_OF_MEANING: 'shades_of_meaning',
  SHOW_OFF: 'show_off',
  SILABALON: 'silabalon',
  SILABALON_LA_COPA: 'silabalon_la_copa',
  SKILL_SCAN: 'skill_scan',
  SKILL_SCAN_AGGREGATE: 'skill_scan_aggregate',
  SLOPPY_SCROLLS: 'sloppy_scrolls',
  SORT_IT_OUT: 'sort_it_out',
  STICKER_BOOK: 'sticker_book',
  STORYBOARD: 'storyboard',
  STORYBOX: 'storybox',
  STORYLAB: 'storylab',
  STUDENT_SETTINGS: 'STUDENT_SETTINGS',
  SUPER_MATCH: 'super_match',
  SYLLABLE_DECODING: 'syllable_decoding',
  TEACHER_DASHBOARD_SETTINGS: 'TEACHER_DASHBOARD_SETTINGS',
  TONGUE_TWIST: 'tongue_twist',
  TRO: 'text_reading_online',
  TRO_BENCHMARK: 'tro_benchmark',
  TUBE_TALES: 'tube_tales',
  UNMASK_THAT: 'unmask_that',
  VOCAB: 'vocab',
  WHATS_THE_BIG_IDEA: 'whats_the_big_idea',
  WILD_PLANET: 'wild_planet',
  WORD_CITY: 'word_city',
  WORD_RAIDERS: 'word_raiders',
  WORD_SLIDE: 'word_slide',
  WORDBOTS: 'wordbots',
  YEARBOOK: 'yearbook',
  ZOOM_BOOM: 'zoom_boom',
};

export default gameIds;
